// SyncE Bridge i18n — all UI strings across every page

export const LANGUAGES = [
  { code:'en', label:'English',    flag:'🇺🇸' },
  { code:'es', label:'Español',    flag:'🇪🇸' },
  { code:'fr', label:'Français',   flag:'🇫🇷' },
  { code:'de', label:'Deutsch',    flag:'🇩🇪' },
  { code:'it', label:'Italiano',   flag:'🇮🇹' },
  { code:'pt', label:'Português',  flag:'🇧🇷' },
  { code:'nl', label:'Nederlands', flag:'🇳🇱' },
  { code:'ja', label:'日本語',      flag:'🇯🇵' },
  { code:'zh', label:'中文',        flag:'🇨🇳' },
]

// ─── English (source of truth) ────────────────────────────────
const en = {
  // ── Nav & Topbar ──────────────────────────────────────────
  nav_dashboard:        'Dashboard',
  nav_products:         'Products',
  nav_orders:           'Orders',
  nav_profiling:        'Listing Rules',
  nav_activity:         'Activity Log',
  nav_pricing:          'Pricing',
  nav_settings:         'Settings',
  nav_shopify:          'Account Details',
  nav_templates:        'Templates',
  nav_help:             'Help & Tutorials',
  menu:                 'Menu',
  shopify_synced:       'Shopify Synced',
  not_synced:           'Not synced yet',
  sync_now:             'Sync Now',
  syncing:              'Syncing…',
  last_sync:            'Last sync',
  language:             'Language',

  // ── Dashboard stats ───────────────────────────────────────
  total_revenue:        'Total Revenue',
  last_30_days:         'Last 30 Days',
  total_orders:         'Total Orders',
  total_products:       'Total Products',
  active_on_ebay:       'Active on eBay',
  inactive:             'Inactive',
  low_stock:            'Low Stock',
  out_of_stock:         'Out of Stock',
  ebay:                 'eBay',
  from_synced:          'From {n} synced eBay orders',
  orders_month:         '{n} orders this month',
  imported:             'Imported from Shopify',
  total_listings:       '{n} total',
  paused_ebay:          'Paused on eBay',
  need_restock:         'Need restocking',
  zero_inventory:       'Zero inventory',
  connected:            'Connected',
  not_connected:        'Not connected',
  synced:               '{n} synced',
  sku_err:              '{n} SKU err',
  failed:               '{n} failed',
  recent_orders:        'Recent Orders',
  recent_activity:      'Recent Activity',
  view_all:             'View all →',
  no_orders_yet:        'No orders synced yet',
  fetch_orders:         'Fetch eBay Orders',
  no_activity:          'No activity yet',
  live_data:            'Live data',
  no_data_yet:          'No data yet',
  import_products:      'Import products from Shopify to see your dashboard.',
  go_products:          '⬡ Go to Products',

  // ── Products page ─────────────────────────────────────────
  import_shopify:       '⬡ Import from Shopify',
  publish_ebay:         'Publish to eBay',
  publishing:           'Publishing…',
  update_ebay:          'Update on eBay',
  link_ebay_listings:   'Link eBay Listings',
  no_products:          'No products imported yet',
  import_first:         'Import your Shopify products to get started.',
  col_image:            'Image',
  col_title:            'Title',
  col_price:            'Price',
  col_inventory:        'Inventory',
  col_profile:          'Profile',
  col_status:           'Status',
  col_actions:          'Actions',
  edit_product:         'Edit Product',
  tab_basic:            'Basic Info',
  tab_variants:         'Variants',
  tab_quality:          'eBay Quality',
  field_title:          'Title',
  field_description:    'Description',
  field_price:          'Price ($)',
  field_inventory:      'Inventory',
  field_vendor:         'Vendor',
  field_product_type:   'Product Type',
  field_tags:           'Tags (comma separated)',
  field_status:         'Status',
  shipping_dims:        'Shipping & Dimensions',
  digital_product:      'Digital Product',
  digital_no_shipping:  'No shipping required — list as downloadable on eBay',
  field_weight:         'Weight',
  field_dimensions:     'Dimensions (L × W × H)',
  save_to_app:          'Save to App',
  saving:               'Saving…',
  status_active:        'Active',
  status_draft:         'Draft',
  status_archived:      'Archived',
  no_variations:        'No variations',
  col_variant:          'Variant',
  col_stock:            'Stock',
  col_sku:              'SKU',
  col_ignore:           'Ignore',
  assign_profile:       'Assign Profile',
  unassign:             'Unassign',
  select_profile:       'Select Profile',
  no_profiles_yet:      'No rules yet — create one in Listing Rules.',
  assigning:            'Assigning…',
  assign:               'Assign',
  analyzing:            'Analysing listing…',

  // ── Orders page ───────────────────────────────────────────
  all_statuses:         'All statuses',
  status_synced:        'In Shopify',
  status_sku_error:     'Product not matched',
  status_failed:        'Failed',
  status_pending:       'Waiting',
  col_receipt:          'eBay order',
  col_buyer:            'Buyer',
  col_items:            'Items',
  col_total:            'Total',
  col_shopify_order:    'Shopify order',
  col_ebay_date:        'eBay Date',
  col_action:           'Action',
  fetch_ebay_orders:    'Get orders from eBay',
  fetch_by_receipt:     'Find one order',
  fix_sku:              '⚠ Fix SKU',
  retry:                '✕ Retry',
  no_orders:            'No orders yet',
  orders_count:         '{n} orders',
  from_label:           'From',
  to_label:             'To',
  fetch:                'Fetch Orders',
  fetching:             '↺ Fetching…',
  fetch_single:         'Fetch Single Order',
  ebay_receipt_id:      'eBay Order ID',
  fix_sku_mapping:      'Fix SKU Mapping',
  create_shopify_order: 'Create Shopify Order',
  creating_order:       'Creating Order…',
  refresh_list:         'Refresh List',
  done_fetched:         'Done — {n} orders fetched',

  // ── Activity page ─────────────────────────────────────────
  all_events:           'All Events',
  errors_tab:           'Errors',
  all_types:            'All types',
  clear_log:            'Clear Log',
  clearing:             'Clearing…',
  no_errors_warnings:   'No errors or warnings',
  total_events:         '{n} total',
  refreshing:           'Refreshing…',

  // ── Settings page ─────────────────────────────────────────
  tab_sync_rules:       'Sync Rules',
  tab_shopify_app:      'From Shopify',
  tab_app_ebay:         'To eBay',
  tab_variations:       'Variations',
  tab_inventory:        'Inventory',
  tab_pricing:          'Pricing',
  tab_notifications:    'Notifications',
  save_settings:        'Save Settings',
  auto_sync_rules:      'Auto Sync Rules',
  loading_settings:     'Loading settings…',
  settings_loaded:      'Settings loaded from database',
  backend_offline:      'Backend offline — changes save locally only',
  every_n_mins:         'Every {n} mins',

  // ── Common ────────────────────────────────────────────────
  save:                 'Save',
  cancel:               'Cancel',
  loading:              'Loading…',
  refresh:              '↺ Refresh',
  create:               'Create',
  edit:                 'Edit',
  delete:               'Delete',
  close:                'Close',
  search:               'Search…',
  none:                 'None',
  yes:                  'Yes',
  no:                   'No',
}

// ─── Spanish ──────────────────────────────────────────────────
const es = {
  nav_dashboard:'Panel', nav_products:'Productos', nav_orders:'Pedidos',
  nav_profiling:'Reglas de listado', nav_activity:'Registro de actividad', nav_pricing:'Precios',
  nav_settings:'Ajustes', nav_shopify:'Detalles de la cuenta', nav_templates:'Plantillas', nav_help:'Ayuda y Tutoriales',
  menu:'Menú', shopify_synced:'Shopify Sincronizado', not_synced:'No sincronizado',
  sync_now:'Sincronizar', syncing:'Sincronizando…', last_sync:'Últ. sincronización', language:'Idioma',

  total_revenue:'Ingresos totales', last_30_days:'Últimos 30 días', total_orders:'Total pedidos',
  total_products:'Total productos', active_on_ebay:'Activos en eBay', inactive:'Inactivos',
  low_stock:'Poco stock', out_of_stock:'Sin stock', ebay:'eBay',
  from_synced:'De {n} pedidos eBay sincronizados', orders_month:'{n} pedidos este mes',
  imported:'Importado de Shopify', total_listings:'{n} en total',
  paused_ebay:'Pausado en eBay', need_restock:'Necesitan reposición',
  zero_inventory:'Inventario cero', connected:'Conectado', not_connected:'No conectado',
  synced:'{n} sincronizados', sku_err:'{n} err SKU', failed:'{n} fallidos',
  recent_orders:'Pedidos recientes', recent_activity:'Actividad reciente',
  view_all:'Ver todos →', no_orders_yet:'Sin pedidos sincronizados',
  fetch_orders:'Obtener pedidos eBay', no_activity:'Sin actividad aún',
  live_data:'Datos en vivo', no_data_yet:'Sin datos aún',
  import_products:'Importa productos de Shopify para ver tu panel.', go_products:'⬡ Ir a Productos',

  import_shopify:'⬡ Importar de Shopify', publish_ebay:'Publicar en eBay',
  publishing:'Publicando…', update_ebay:'Actualizar en eBay',
  link_ebay_listings:'Vincular listados eBay', no_products:'Sin productos importados',
  import_first:'Importa tus productos de Shopify para comenzar.',
  col_image:'Imagen', col_title:'Título', col_price:'Precio',
  col_inventory:'Inventario', col_profile:'Perfil', col_status:'Estado', col_actions:'Acciones',
  edit_product:'Editar Producto', tab_basic:'Info Básica', tab_variants:'Variantes',
  tab_quality:'Calidad eBay', field_title:'Título', field_description:'Descripción',
  field_price:'Precio ($)', field_inventory:'Inventario', field_vendor:'Proveedor',
  field_product_type:'Tipo de producto', field_tags:'Etiquetas (separadas por comas)',
  field_status:'Estado', shipping_dims:'Envío y Dimensiones', digital_product:'Producto Digital',
  digital_no_shipping:'Sin envío — listar como descargable en eBay',
  field_weight:'Peso', field_dimensions:'Dimensiones (L × A × H)',
  save_to_app:'Guardar en App', saving:'Guardando…',
  status_active:'Activo', status_draft:'Borrador', status_archived:'Archivado',
  no_variations:'Sin variaciones', col_variant:'Variante', col_stock:'Stock',
  col_sku:'SKU', col_ignore:'Ignorar', assign_profile:'Asignar Perfil',
  unassign:'Desasignar', select_profile:'Seleccionar Perfil',
  no_profiles_yet:'Sin perfiles aún — crea uno en Perfiles.',
  assigning:'Asignando…', assign:'Asignar', analyzing:'Analizando listado…',

  all_statuses:'Todos los estados', status_synced:'Sincronizado',
  status_sku_error:'Error SKU', status_failed:'Fallido', status_pending:'Pendiente',
  col_receipt:'ID de pedido', col_buyer:'Comprador', col_items:'Artículos',
  col_total:'Total', col_shopify_order:'Pedido Shopify', col_ebay_date:'Fecha eBay',
  col_action:'Acción', fetch_ebay_orders:'↓ Obtener pedidos eBay',
  fetch_by_receipt:'# Buscar por ID de pedido', fix_sku:'⚠ Corregir SKU',
  retry:'✕ Reintentar', no_orders:'Sin pedidos aún', orders_count:'{n} pedidos',
  from_label:'Desde', to_label:'Hasta', fetch:'Obtener pedidos',
  fetching:'↺ Obteniendo…', fetch_single:'Obtener pedido único',
  ebay_receipt_id:'ID de pedido eBay', fix_sku_mapping:'Corregir mapeo SKU',
  create_shopify_order:'Crear pedido Shopify', creating_order:'Creando pedido…',
  refresh_list:'Actualizar lista', done_fetched:'Listo — {n} recibos obtenidos',

  all_events:'Todos los eventos', errors_tab:'Errores', all_types:'Todos los tipos',
  clear_log:'Limpiar registro', clearing:'Limpiando…',
  no_errors_warnings:'Sin errores ni advertencias', total_events:'{n} en total',
  refreshing:'Actualizando…',

  tab_sync_rules:'Reglas de sync', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variaciones',
  tab_inventory:'Inventario', tab_pricing:'Precios', tab_notifications:'Notificaciones',
  save_settings:'Guardar ajustes', auto_sync_rules:'Reglas de Auto-Sync',
  loading_settings:'Cargando ajustes…', settings_loaded:'Ajustes cargados de la base de datos',
  backend_offline:'Backend offline — los cambios se guardan solo localmente',
  every_n_mins:'Cada {n} mins',

  save:'Guardar', cancel:'Cancelar', loading:'Cargando…', refresh:'↺ Actualizar',
  create:'Crear', edit:'Editar', delete:'Eliminar', close:'Cerrar',
  search:'Buscar…', none:'Ninguno', yes:'Sí', no:'No',
}

// ─── French ───────────────────────────────────────────────────
const fr = {
  nav_dashboard:'Tableau de bord', nav_products:'Produits', nav_orders:'Commandes',
  nav_profiling:'Règles annonce', nav_activity:'Journal activité', nav_pricing:'Tarification',
  nav_settings:'Paramètres', nav_shopify:'Détails du compte', nav_templates:'Modèles', nav_help:'Aide & Tutoriels',
  menu:'Menu', shopify_synced:'Shopify Synchronisé', not_synced:'Non synchronisé',
  sync_now:'Synchroniser', syncing:'Sync en cours…', last_sync:'Dernière sync', language:'Langue',

  total_revenue:'Revenus totaux', last_30_days:'30 derniers jours', total_orders:'Total commandes',
  total_products:'Total produits', active_on_ebay:'Actifs sur eBay', inactive:'Inactifs',
  low_stock:'Stock faible', out_of_stock:'Rupture de stock', ebay:'eBay',
  from_synced:'De {n} commandes eBay synchronisées', orders_month:'{n} commandes ce mois',
  imported:'Importé depuis Shopify', total_listings:'{n} au total',
  paused_ebay:'En pause sur eBay', need_restock:'Réapprovisionnement nécessaire',
  zero_inventory:'Inventaire zéro', connected:'Connecté', not_connected:'Non connecté',
  synced:'{n} synchronisés', sku_err:'{n} err SKU', failed:'{n} échoués',
  recent_orders:'Commandes récentes', recent_activity:'Activité récente',
  view_all:'Voir tout →', no_orders_yet:'Aucune commande synchronisée',
  fetch_orders:'Récupérer les commandes eBay', no_activity:"Pas encore d'activité",
  live_data:'Données en direct', no_data_yet:'Pas encore de données',
  import_products:'Importez des produits Shopify pour voir votre tableau de bord.',
  go_products:'⬡ Aller aux Produits',

  import_shopify:'⬡ Importer depuis Shopify', publish_ebay:'Publier sur eBay',
  publishing:'Publication…', update_ebay:'Mettre à jour sur eBay',
  link_ebay_listings:'Lier les annonces eBay', no_products:'Aucun produit importé',
  import_first:'Importez vos produits Shopify pour commencer.',
  col_image:'Image', col_title:'Titre', col_price:'Prix',
  col_inventory:'Inventaire', col_profile:'Profil', col_status:'Statut', col_actions:'Actions',
  edit_product:'Modifier le produit', tab_basic:'Infos de base', tab_variants:'Variantes',
  tab_quality:'Qualité eBay', field_title:'Titre', field_description:'Description',
  field_price:'Prix ($)', field_inventory:'Inventaire', field_vendor:'Fournisseur',
  field_product_type:'Type de produit', field_tags:'Étiquettes (séparées par virgule)',
  field_status:'Statut', shipping_dims:'Expédition et Dimensions',
  digital_product:'Produit numérique',
  digital_no_shipping:'Sans livraison — lister comme téléchargeable sur eBay',
  field_weight:'Poids', field_dimensions:'Dimensions (L × l × H)',
  save_to_app:"Enregistrer dans l'app", saving:'Enregistrement…',
  status_active:'Actif', status_draft:'Brouillon', status_archived:'Archivé',
  no_variations:'Pas de variantes', col_variant:'Variante', col_stock:'Stock',
  col_sku:'SKU', col_ignore:'Ignorer', assign_profile:'Attribuer un profil',
  unassign:'Retirer', select_profile:'Choisir un profil',
  no_profiles_yet:"Pas encore de profil — créez-en un dans Profils.",
  assigning:'Attribution…', assign:'Attribuer', analyzing:"Analyse de l'annonce…",

  all_statuses:'Tous les statuts', status_synced:'Synchronisé',
  status_sku_error:'Erreur SKU', status_failed:'Échoué', status_pending:'En attente',
  col_receipt:'ID commande', col_buyer:'Acheteur', col_items:'Articles',
  col_total:'Total', col_shopify_order:'Commande Shopify', col_ebay_date:'Date eBay',
  col_action:'Action', fetch_ebay_orders:'↓ Récupérer commandes eBay',
  fetch_by_receipt:'# Recherche par ID de commande', fix_sku:'⚠ Corriger SKU',
  retry:'✕ Réessayer', no_orders:'Pas encore de commandes', orders_count:'{n} commandes',
  from_label:'Du', to_label:'Au', fetch:'Récupérer commandes',
  fetching:'↺ Récupération…', fetch_single:'Récupérer une commande',
  ebay_receipt_id:'ID de commande eBay', fix_sku_mapping:'Corriger le mapping SKU',
  create_shopify_order:'Créer commande Shopify', creating_order:'Création…',
  refresh_list:'Actualiser la liste', done_fetched:'Terminé — {n} reçus récupérés',

  all_events:'Tous les événements', errors_tab:'Erreurs', all_types:'Tous types',
  clear_log:'Vider le journal', clearing:'Nettoyage…',
  no_errors_warnings:'Aucune erreur ni avertissement', total_events:'{n} au total',
  refreshing:'Actualisation…',

  tab_sync_rules:'Règles de sync', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variations',
  tab_inventory:'Inventaire', tab_pricing:'Tarification', tab_notifications:'Notifications',
  save_settings:'Enregistrer les paramètres', auto_sync_rules:'Règles de synchronisation auto',
  loading_settings:'Chargement des paramètres…',
  settings_loaded:'Paramètres chargés depuis la base de données',
  backend_offline:'Backend hors ligne — les modifications sont sauvegardées localement',
  every_n_mins:'Toutes les {n} min',

  save:'Enregistrer', cancel:'Annuler', loading:'Chargement…', refresh:'↺ Actualiser',
  create:'Créer', edit:'Modifier', delete:'Supprimer', close:'Fermer',
  search:'Rechercher…', none:'Aucun', yes:'Oui', no:'Non',
}

// ─── German ───────────────────────────────────────────────────
const de = {
  nav_dashboard:'Dashboard', nav_products:'Produkte', nav_orders:'Bestellungen',
  nav_profiling:'Listing-Regeln', nav_activity:'Aktivitätslog', nav_pricing:'Preise',
  nav_settings:'Einstellungen', nav_shopify:'Kontodetails', nav_templates:'Vorlagen', nav_help:'Hilfe & Tutorials',
  menu:'Menü', shopify_synced:'Shopify Synchronisiert', not_synced:'Nicht synchronisiert',
  sync_now:'Sync starten', syncing:'Synchronisiere…', last_sync:'Letzter Sync', language:'Sprache',

  total_revenue:'Gesamtumsatz', last_30_days:'Letzte 30 Tage', total_orders:'Gesamtbestellungen',
  total_products:'Gesamtprodukte', active_on_ebay:'Aktiv auf eBay', inactive:'Inaktiv',
  low_stock:'Geringer Bestand', out_of_stock:'Ausverkauft', ebay:'eBay',
  from_synced:'Aus {n} synchronisierten eBay-Bestellungen',
  orders_month:'{n} Bestellungen diesen Monat', imported:'Von Shopify importiert',
  total_listings:'{n} gesamt', paused_ebay:'Auf eBay pausiert',
  need_restock:'Nachbestellung nötig', zero_inventory:'Nullbestand',
  connected:'Verbunden', not_connected:'Nicht verbunden',
  synced:'{n} synchronisiert', sku_err:'{n} SKU-Fehler', failed:'{n} fehlgeschlagen',
  recent_orders:'Aktuelle Bestellungen', recent_activity:'Aktuelle Aktivität',
  view_all:'Alle anzeigen →', no_orders_yet:'Keine Bestellungen synchronisiert',
  fetch_orders:'eBay-Bestellungen abrufen', no_activity:'Noch keine Aktivität',
  live_data:'Live-Daten', no_data_yet:'Noch keine Daten',
  import_products:'Importiere Shopify-Produkte, um dein Dashboard zu sehen.',
  go_products:'⬡ Zu Produkten',

  import_shopify:'⬡ Von Shopify importieren', publish_ebay:'Auf eBay veröffentlichen',
  publishing:'Veröffentliche…', update_ebay:'Auf eBay aktualisieren',
  link_ebay_listings:'eBay-Listings verknüpfen', no_products:'Keine Produkte importiert',
  import_first:'Importiere deine Shopify-Produkte, um zu beginnen.',
  col_image:'Bild', col_title:'Titel', col_price:'Preis',
  col_inventory:'Bestand', col_profile:'Profil', col_status:'Status', col_actions:'Aktionen',
  edit_product:'Produkt bearbeiten', tab_basic:'Basisinfo', tab_variants:'Varianten',
  tab_quality:'eBay-Qualität', field_title:'Titel', field_description:'Beschreibung',
  field_price:'Preis ($)', field_inventory:'Bestand', field_vendor:'Anbieter',
  field_product_type:'Produkttyp', field_tags:'Tags (kommagetrennt)',
  field_status:'Status', shipping_dims:'Versand & Abmessungen',
  digital_product:'Digitales Produkt',
  digital_no_shipping:'Kein Versand — als herunterladbar auf eBay listen',
  field_weight:'Gewicht', field_dimensions:'Abmessungen (L × B × H)',
  save_to_app:'In App speichern', saving:'Speichern…',
  status_active:'Aktiv', status_draft:'Entwurf', status_archived:'Archiviert',
  no_variations:'Keine Varianten', col_variant:'Variante', col_stock:'Bestand',
  col_sku:'SKU', col_ignore:'Ignorieren', assign_profile:'Profil zuweisen',
  unassign:'Zuweisung aufheben', select_profile:'Profil auswählen',
  no_profiles_yet:'Noch keine Profile — erstelle eines in Profile.',
  assigning:'Zuweisen…', assign:'Zuweisen', analyzing:'Listing wird analysiert…',

  all_statuses:'Alle Status', status_synced:'Synchronisiert',
  status_sku_error:'SKU-Fehler', status_failed:'Fehlgeschlagen', status_pending:'Ausstehend',
  col_receipt:'Bestell-ID', col_buyer:'Käufer', col_items:'Artikel',
  col_total:'Gesamt', col_shopify_order:'Shopify-Bestellung', col_ebay_date:'eBay-Datum',
  col_action:'Aktion', fetch_ebay_orders:'↓ eBay-Bestellungen abrufen',
  fetch_by_receipt:'# Suche nach Bestell-ID', fix_sku:'⚠ SKU korrigieren',
  retry:'✕ Wiederholen', no_orders:'Noch keine Bestellungen', orders_count:'{n} Bestellungen',
  from_label:'Von', to_label:'Bis', fetch:'Bestellungen abrufen',
  fetching:'↺ Abrufen…', fetch_single:'Einzelne Bestellung abrufen',
  ebay_receipt_id:'eBay Beleg-ID', fix_sku_mapping:'SKU-Zuordnung korrigieren',
  create_shopify_order:'Shopify-Bestellung erstellen', creating_order:'Erstelle Bestellung…',
  refresh_list:'Liste aktualisieren', done_fetched:'Fertig — {n} Belege abgerufen',

  all_events:'Alle Ereignisse', errors_tab:'Fehler', all_types:'Alle Typen',
  clear_log:'Protokoll leeren', clearing:'Wird geleert…',
  no_errors_warnings:'Keine Fehler oder Warnungen', total_events:'{n} gesamt',
  refreshing:'Aktualisiere…',

  tab_sync_rules:'Sync-Regeln', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variationen',
  tab_inventory:'Bestand', tab_pricing:'Preise', tab_notifications:'Benachrichtigungen',
  save_settings:'Einstellungen speichern', auto_sync_rules:'Auto-Sync Regeln',
  loading_settings:'Einstellungen werden geladen…',
  settings_loaded:'Einstellungen aus der Datenbank geladen',
  backend_offline:'Backend offline — Änderungen werden nur lokal gespeichert',
  every_n_mins:'Alle {n} Min.',

  save:'Speichern', cancel:'Abbrechen', loading:'Lädt…', refresh:'↺ Aktualisieren',
  create:'Erstellen', edit:'Bearbeiten', delete:'Löschen', close:'Schließen',
  search:'Suchen…', none:'Keine', yes:'Ja', no:'Nein',
}

// ─── Italian ──────────────────────────────────────────────────
const it = {
  nav_dashboard:'Dashboard', nav_products:'Prodotti', nav_orders:'Ordini',
  nav_profiling:'Regole annuncio', nav_activity:'Registro attività', nav_pricing:'Prezzi',
  nav_settings:'Impostazioni', nav_shopify:'Dettagli account', nav_templates:'Modelli', nav_help:'Guida e Tutorial',
  menu:'Menu', shopify_synced:'Shopify Sincronizzato', not_synced:'Non sincronizzato',
  sync_now:'Sincronizza', syncing:'Sincronizzazione…', last_sync:'Ultima sync', language:'Lingua',

  total_revenue:'Ricavi totali', last_30_days:'Ultimi 30 giorni', total_orders:'Totale ordini',
  total_products:'Totale prodotti', active_on_ebay:'Attivi su eBay', inactive:'Inattivi',
  low_stock:'Scorte basse', out_of_stock:'Esaurito', ebay:'eBay',
  from_synced:'Da {n} ordini eBay sincronizzati', orders_month:'{n} ordini questo mese',
  imported:'Importato da Shopify', total_listings:'{n} totale',
  paused_ebay:'In pausa su eBay', need_restock:'Rifornimento necessario',
  zero_inventory:'Inventario zero', connected:'Connesso', not_connected:'Non connesso',
  synced:'{n} sincronizzati', sku_err:'{n} err SKU', failed:'{n} falliti',
  recent_orders:'Ordini recenti', recent_activity:'Attività recente',
  view_all:'Vedi tutto →', no_orders_yet:'Nessun ordine sincronizzato',
  fetch_orders:'Recupera ordini eBay', no_activity:'Nessuna attività',
  live_data:'Dati in tempo reale', no_data_yet:'Nessun dato',
  import_products:'Importa prodotti da Shopify per vedere la tua dashboard.',
  go_products:'⬡ Vai ai Prodotti',

  import_shopify:'⬡ Importa da Shopify', publish_ebay:'Pubblica su eBay',
  publishing:'Pubblicazione…', update_ebay:'Aggiorna su eBay',
  link_ebay_listings:'Collega annunci eBay', no_products:'Nessun prodotto importato',
  import_first:'Importa i tuoi prodotti Shopify per iniziare.',
  col_image:'Immagine', col_title:'Titolo', col_price:'Prezzo',
  col_inventory:'Inventario', col_profile:'Profilo', col_status:'Stato', col_actions:'Azioni',
  edit_product:'Modifica prodotto', tab_basic:'Info base', tab_variants:'Varianti',
  tab_quality:'Qualità eBay', field_title:'Titolo', field_description:'Descrizione',
  field_price:'Prezzo ($)', field_inventory:'Inventario', field_vendor:'Fornitore',
  field_product_type:'Tipo prodotto', field_tags:'Tag (separati da virgola)',
  field_status:'Stato', shipping_dims:'Spedizione e Dimensioni',
  digital_product:'Prodotto digitale',
  digital_no_shipping:'Senza spedizione — elenca come scaricabile su eBay',
  field_weight:'Peso', field_dimensions:'Dimensioni (L × L × H)',
  save_to_app:"Salva nell'app", saving:'Salvataggio…',
  status_active:'Attivo', status_draft:'Bozza', status_archived:'Archiviato',
  no_variations:'Nessuna variante', col_variant:'Variante', col_stock:'Stock',
  col_sku:'SKU', col_ignore:'Ignora', assign_profile:'Assegna profilo',
  unassign:'Rimuovi assegnazione', select_profile:'Seleziona profilo',
  no_profiles_yet:'Nessun profilo — creane uno in Profili.',
  assigning:'Assegnazione…', assign:'Assegna', analyzing:"Analisi dell'annuncio…",

  all_statuses:'Tutti gli stati', status_synced:'Sincronizzato',
  status_sku_error:'Errore SKU', status_failed:'Fallito', status_pending:'In attesa',
  col_receipt:'ID Ricevuta', col_buyer:'Acquirente', col_items:'Articoli',
  col_total:'Totale', col_shopify_order:'Ordine Shopify', col_ebay_date:'Data eBay',
  col_action:'Azione', fetch_ebay_orders:'↓ Recupera ordini eBay',
  fetch_by_receipt:'# Cerca per ID ricevuta', fix_sku:'⚠ Correggi SKU',
  retry:'✕ Riprova', no_orders:'Nessun ordine ancora', orders_count:'{n} ordini',
  from_label:'Dal', to_label:'Al', fetch:'Recupera ordini',
  fetching:'↺ Recupero…', fetch_single:'Recupera ordine singolo',
  ebay_receipt_id:'ID ricevuta eBay', fix_sku_mapping:'Correggi mapping SKU',
  create_shopify_order:'Crea ordine Shopify', creating_order:'Creazione ordine…',
  refresh_list:'Aggiorna lista', done_fetched:'Fatto — {n} ricevute recuperate',

  all_events:'Tutti gli eventi', errors_tab:'Errori', all_types:'Tutti i tipi',
  clear_log:'Svuota registro', clearing:'Pulizia…',
  no_errors_warnings:'Nessun errore o avviso', total_events:'{n} in totale',
  refreshing:'Aggiornamento…',

  tab_sync_rules:'Regole sync', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variazioni',
  tab_inventory:'Inventario', tab_pricing:'Prezzi', tab_notifications:'Notifiche',
  save_settings:'Salva impostazioni', auto_sync_rules:'Regole Auto-Sync',
  loading_settings:'Caricamento impostazioni…',
  settings_loaded:'Impostazioni caricate dal database',
  backend_offline:'Backend offline — le modifiche vengono salvate solo localmente',
  every_n_mins:'Ogni {n} min',

  save:'Salva', cancel:'Annulla', loading:'Caricamento…', refresh:'↺ Aggiorna',
  create:'Crea', edit:'Modifica', delete:'Elimina', close:'Chiudi',
  search:'Cerca…', none:'Nessuno', yes:'Sì', no:'No',
}

// ─── Portuguese ───────────────────────────────────────────────
const pt = {
  nav_dashboard:'Painel', nav_products:'Produtos', nav_orders:'Pedidos',
  nav_profiling:'Regras de listagem', nav_activity:'Registro de atividade', nav_pricing:'Preços',
  nav_settings:'Configurações', nav_shopify:'Detalhes da conta', nav_templates:'Modelos', nav_help:'Ajuda e Tutoriais',
  menu:'Menu', shopify_synced:'Shopify Sincronizado', not_synced:'Não sincronizado',
  sync_now:'Sincronizar', syncing:'Sincronizando…', last_sync:'Última sync', language:'Idioma',

  total_revenue:'Receita total', last_30_days:'Últimos 30 dias', total_orders:'Total de pedidos',
  total_products:'Total de produtos', active_on_ebay:'Ativos no eBay', inactive:'Inativos',
  low_stock:'Estoque baixo', out_of_stock:'Sem estoque', ebay:'eBay',
  from_synced:'De {n} pedidos eBay sincronizados', orders_month:'{n} pedidos este mês',
  imported:'Importado do Shopify', total_listings:'{n} no total',
  paused_ebay:'Pausado no eBay', need_restock:'Precisa de reposição',
  zero_inventory:'Inventário zero', connected:'Conectado', not_connected:'Não conectado',
  synced:'{n} sincronizados', sku_err:'{n} err SKU', failed:'{n} falhos',
  recent_orders:'Pedidos recentes', recent_activity:'Atividade recente',
  view_all:'Ver tudo →', no_orders_yet:'Nenhum pedido sincronizado',
  fetch_orders:'Buscar pedidos do eBay', no_activity:'Sem atividade ainda',
  live_data:'Dados ao vivo', no_data_yet:'Sem dados ainda',
  import_products:'Importe produtos do Shopify para ver seu painel.',
  go_products:'⬡ Ir para Produtos',

  import_shopify:'⬡ Importar do Shopify', publish_ebay:'Publicar no eBay',
  publishing:'Publicando…', update_ebay:'Atualizar no eBay',
  link_ebay_listings:'Vincular anúncios eBay', no_products:'Nenhum produto importado',
  import_first:'Importe seus produtos do Shopify para começar.',
  col_image:'Imagem', col_title:'Título', col_price:'Preço',
  col_inventory:'Inventário', col_profile:'Perfil', col_status:'Status', col_actions:'Ações',
  edit_product:'Editar Produto', tab_basic:'Info Básica', tab_variants:'Variantes',
  tab_quality:'Qualidade eBay', field_title:'Título', field_description:'Descrição',
  field_price:'Preço ($)', field_inventory:'Inventário', field_vendor:'Fornecedor',
  field_product_type:'Tipo de produto', field_tags:'Tags (separadas por vírgula)',
  field_status:'Status', shipping_dims:'Envio e Dimensões',
  digital_product:'Produto Digital',
  digital_no_shipping:'Sem envio — listar como download no eBay',
  field_weight:'Peso', field_dimensions:'Dimensões (C × L × A)',
  save_to_app:'Salvar no App', saving:'Salvando…',
  status_active:'Ativo', status_draft:'Rascunho', status_archived:'Arquivado',
  no_variations:'Sem variações', col_variant:'Variante', col_stock:'Estoque',
  col_sku:'SKU', col_ignore:'Ignorar', assign_profile:'Atribuir Perfil',
  unassign:'Remover atribuição', select_profile:'Selecionar Perfil',
  no_profiles_yet:'Sem perfis — crie um em Perfis.',
  assigning:'Atribuindo…', assign:'Atribuir', analyzing:'Analisando anúncio…',

  all_statuses:'Todos os status', status_synced:'Sincronizado',
  status_sku_error:'Erro SKU', status_failed:'Falhou', status_pending:'Pendente',
  col_receipt:'ID de pedido', col_buyer:'Comprador', col_items:'Itens',
  col_total:'Total', col_shopify_order:'Pedido Shopify', col_ebay_date:'Data eBay',
  col_action:'Ação', fetch_ebay_orders:'↓ Buscar pedidos eBay',
  fetch_by_receipt:'# Buscar por ID de pedido', fix_sku:'⚠ Corrigir SKU',
  retry:'✕ Tentar novamente', no_orders:'Sem pedidos ainda', orders_count:'{n} pedidos',
  from_label:'De', to_label:'Até', fetch:'Buscar pedidos',
  fetching:'↺ Buscando…', fetch_single:'Buscar pedido único',
  ebay_receipt_id:'ID de pedido eBay', fix_sku_mapping:'Corrigir mapeamento SKU',
  create_shopify_order:'Criar pedido Shopify', creating_order:'Criando pedido…',
  refresh_list:'Atualizar lista', done_fetched:'Concluído — {n} recibos obtidos',

  all_events:'Todos os eventos', errors_tab:'Erros', all_types:'Todos os tipos',
  clear_log:'Limpar registro', clearing:'Limpando…',
  no_errors_warnings:'Sem erros ou avisos', total_events:'{n} no total',
  refreshing:'Atualizando…',

  tab_sync_rules:'Regras de sync', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variações',
  tab_inventory:'Inventário', tab_pricing:'Preços', tab_notifications:'Notificações',
  save_settings:'Salvar configurações', auto_sync_rules:'Regras de Auto-Sync',
  loading_settings:'Carregando configurações…',
  settings_loaded:'Configurações carregadas do banco de dados',
  backend_offline:'Backend offline — as alterações são salvas apenas localmente',
  every_n_mins:'A cada {n} min',

  save:'Salvar', cancel:'Cancelar', loading:'Carregando…', refresh:'↺ Atualizar',
  create:'Criar', edit:'Editar', delete:'Excluir', close:'Fechar',
  search:'Pesquisar…', none:'Nenhum', yes:'Sim', no:'Não',
}

// ─── Dutch ────────────────────────────────────────────────────
const nl = {
  nav_dashboard:'Dashboard', nav_products:'Producten', nav_orders:'Bestellingen',
  nav_profiling:'Listing-regels', nav_activity:'Activiteitenlog', nav_pricing:'Prijzen',
  nav_settings:'Instellingen', nav_shopify:'Accountgegevens', nav_templates:'Sjablonen', nav_help:'Help & Tutorials',
  menu:'Menu', shopify_synced:'Shopify Gesynchroniseerd', not_synced:'Niet gesynchroniseerd',
  sync_now:'Nu synchroniseren', syncing:'Synchroniseren…', last_sync:'Laatste sync', language:'Taal',

  total_revenue:'Totale omzet', last_30_days:'Laatste 30 dagen', total_orders:'Totaal bestellingen',
  total_products:'Totaal producten', active_on_ebay:'Actief op eBay', inactive:'Inactief',
  low_stock:'Lage voorraad', out_of_stock:'Uitverkocht', ebay:'eBay',
  from_synced:'Van {n} gesynchroniseerde eBay-bestellingen',
  orders_month:'{n} bestellingen deze maand', imported:'Geïmporteerd vanuit Shopify',
  total_listings:'{n} totaal', paused_ebay:'Gepauzeerd op eBay',
  need_restock:'Aanvulling nodig', zero_inventory:'Nul voorraad',
  connected:'Verbonden', not_connected:'Niet verbonden',
  synced:'{n} gesynchroniseerd', sku_err:'{n} SKU-fout', failed:'{n} mislukt',
  recent_orders:'Recente bestellingen', recent_activity:'Recente activiteit',
  view_all:'Alles bekijken →', no_orders_yet:'Geen bestellingen gesynchroniseerd',
  fetch_orders:'eBay-bestellingen ophalen', no_activity:'Nog geen activiteit',
  live_data:'Live data', no_data_yet:'Nog geen gegevens',
  import_products:'Importeer Shopify-producten om je dashboard te zien.',
  go_products:'⬡ Naar Producten',

  import_shopify:'⬡ Importeren uit Shopify', publish_ebay:'Publiceren op eBay',
  publishing:'Publiceren…', update_ebay:'Bijwerken op eBay',
  link_ebay_listings:'eBay-vermeldingen koppelen', no_products:'Geen producten geïmporteerd',
  import_first:'Importeer je Shopify-producten om te beginnen.',
  col_image:'Afbeelding', col_title:'Titel', col_price:'Prijs',
  col_inventory:'Voorraad', col_profile:'Profiel', col_status:'Status', col_actions:'Acties',
  edit_product:'Product bewerken', tab_basic:'Basisinfo', tab_variants:'Varianten',
  tab_quality:'eBay Kwaliteit', field_title:'Titel', field_description:'Beschrijving',
  field_price:'Prijs ($)', field_inventory:'Voorraad', field_vendor:'Leverancier',
  field_product_type:'Producttype', field_tags:'Tags (kommagescheiden)',
  field_status:'Status', shipping_dims:'Verzending & Afmetingen',
  digital_product:'Digitaal product',
  digital_no_shipping:'Geen verzending — vermelden als downloadbaar op eBay',
  field_weight:'Gewicht', field_dimensions:'Afmetingen (L × B × H)',
  save_to_app:'Opslaan in app', saving:'Opslaan…',
  status_active:'Actief', status_draft:'Concept', status_archived:'Gearchiveerd',
  no_variations:'Geen varianten', col_variant:'Variant', col_stock:'Voorraad',
  col_sku:'SKU', col_ignore:'Negeren', assign_profile:'Profiel toewijzen',
  unassign:'Toewijzing verwijderen', select_profile:'Profiel kiezen',
  no_profiles_yet:'Nog geen profielen — maak er een in Profielen.',
  assigning:'Toewijzen…', assign:'Toewijzen', analyzing:'Vermelding analyseren…',

  all_statuses:'Alle statussen', status_synced:'Gesynchroniseerd',
  status_sku_error:'SKU-fout', status_failed:'Mislukt', status_pending:'In behandeling',
  col_receipt:'Bon-ID', col_buyer:'Koper', col_items:'Artikelen',
  col_total:'Totaal', col_shopify_order:'Shopify-bestelling', col_ebay_date:'eBay datum',
  col_action:'Actie', fetch_ebay_orders:'↓ eBay-bestellingen ophalen',
  fetch_by_receipt:'# Zoeken op bon-ID', fix_sku:'⚠ SKU herstellen',
  retry:'✕ Opnieuw proberen', no_orders:'Nog geen bestellingen', orders_count:'{n} bestellingen',
  from_label:'Van', to_label:'Tot', fetch:'Bestellingen ophalen',
  fetching:'↺ Ophalen…', fetch_single:'Enkele bestelling ophalen',
  ebay_receipt_id:'eBay bon-ID', fix_sku_mapping:'SKU-koppeling herstellen',
  create_shopify_order:'Shopify-bestelling aanmaken', creating_order:'Bestelling aanmaken…',
  refresh_list:'Lijst vernieuwen', done_fetched:'Klaar — {n} bonnen opgehaald',

  all_events:'Alle gebeurtenissen', errors_tab:'Fouten', all_types:'Alle typen',
  clear_log:'Logboek wissen', clearing:'Wissen…',
  no_errors_warnings:'Geen fouten of waarschuwingen', total_events:'{n} totaal',
  refreshing:'Vernieuwen…',

  tab_sync_rules:'Sync-regels', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'Variaties',
  tab_inventory:'Voorraad', tab_pricing:'Prijzen', tab_notifications:'Meldingen',
  save_settings:'Instellingen opslaan', auto_sync_rules:'Auto-sync regels',
  loading_settings:'Instellingen laden…',
  settings_loaded:'Instellingen geladen uit database',
  backend_offline:'Backend offline — wijzigingen worden alleen lokaal opgeslagen',
  every_n_mins:'Elke {n} min',

  save:'Opslaan', cancel:'Annuleren', loading:'Laden…', refresh:'↺ Vernieuwen',
  create:'Aanmaken', edit:'Bewerken', delete:'Verwijderen', close:'Sluiten',
  search:'Zoeken…', none:'Geen', yes:'Ja', no:'Nee',
}

// ─── Japanese ─────────────────────────────────────────────────
const ja = {
  nav_dashboard:'ダッシュボード', nav_products:'商品', nav_orders:'注文',
  nav_profiling:'リストルール', nav_activity:'アクティビティログ', nav_pricing:'料金',
  nav_settings:'設定', nav_shopify:'アカウント詳細', nav_templates:'テンプレート', nav_help:'ヘルプ・チュートリアル',
  menu:'メニュー', shopify_synced:'Shopify同期済み', not_synced:'未同期',
  sync_now:'今すぐ同期', syncing:'同期中…', last_sync:'最終同期', language:'言語',

  total_revenue:'総収益', last_30_days:'過去30日間', total_orders:'総注文数',
  total_products:'総商品数', active_on_ebay:'eBayで公開中', inactive:'非アクティブ',
  low_stock:'在庫少', out_of_stock:'在庫切れ', ebay:'eBay',
  from_synced:'{n}件のeBay注文から', orders_month:'今月{n}件の注文',
  imported:'Shopifyからインポート済み', total_listings:'合計{n}件',
  paused_ebay:'eBayで一時停止中', need_restock:'補充が必要',
  zero_inventory:'在庫ゼロ', connected:'接続済み', not_connected:'未接続',
  synced:'{n}件同期済み', sku_err:'{n}件SKUエラー', failed:'{n}件失敗',
  recent_orders:'最近の注文', recent_activity:'最近のアクティビティ',
  view_all:'すべて表示 →', no_orders_yet:'注文が同期されていません',
  fetch_orders:'eBay注文を取得', no_activity:'アクティビティなし',
  live_data:'リアルタイムデータ', no_data_yet:'データなし',
  import_products:'ダッシュボードを表示するにはShopify商品をインポートしてください。',
  go_products:'⬡ 商品へ移動',

  import_shopify:'⬡ Shopifyからインポート', publish_ebay:'eBayに出品',
  publishing:'出品中…', update_ebay:'eBayで更新',
  link_ebay_listings:'eBayリスティングをリンク', no_products:'商品がインポートされていません',
  import_first:'Shopify商品をインポートして始めましょう。',
  col_image:'画像', col_title:'タイトル', col_price:'価格',
  col_inventory:'在庫', col_profile:'プロフィール', col_status:'ステータス', col_actions:'操作',
  edit_product:'商品を編集', tab_basic:'基本情報', tab_variants:'バリエーション',
  tab_quality:'eBay品質', field_title:'タイトル', field_description:'説明',
  field_price:'価格 ($)', field_inventory:'在庫', field_vendor:'ベンダー',
  field_product_type:'商品タイプ', field_tags:'タグ（カンマ区切り）',
  field_status:'ステータス', shipping_dims:'配送と寸法',
  digital_product:'デジタル商品',
  digital_no_shipping:'配送不要 — eBayでダウンロード可能として出品',
  field_weight:'重量', field_dimensions:'寸法 (縦 × 横 × 高)',
  save_to_app:'アプリに保存', saving:'保存中…',
  status_active:'アクティブ', status_draft:'下書き', status_archived:'アーカイブ',
  no_variations:'バリエーションなし', col_variant:'バリエーション', col_stock:'在庫数',
  col_sku:'SKU', col_ignore:'無視', assign_profile:'プロフィールを割り当て',
  unassign:'割り当て解除', select_profile:'プロフィールを選択',
  no_profiles_yet:'プロフィールなし — プロフィールページで作成してください。',
  assigning:'割り当て中…', assign:'割り当て', analyzing:'リスティング分析中…',

  all_statuses:'全ステータス', status_synced:'同期済み',
  status_sku_error:'SKUエラー', status_failed:'失敗', status_pending:'保留中',
  col_receipt:'受取ID', col_buyer:'購入者', col_items:'商品',
  col_total:'合計', col_shopify_order:'Shopify注文', col_ebay_date:'eBay日付',
  col_action:'操作', fetch_ebay_orders:'↓ eBay注文を取得',
  fetch_by_receipt:'# 受取IDで検索', fix_sku:'⚠ SKUを修正',
  retry:'✕ 再試行', no_orders:'注文なし', orders_count:'{n}件の注文',
  from_label:'開始日', to_label:'終了日', fetch:'注文を取得',
  fetching:'↺ 取得中…', fetch_single:'単一注文を取得',
  ebay_receipt_id:'eBay受取ID', fix_sku_mapping:'SKUマッピングを修正',
  create_shopify_order:'Shopify注文を作成', creating_order:'注文作成中…',
  refresh_list:'リストを更新', done_fetched:'完了 — {n}件取得',

  all_events:'全イベント', errors_tab:'エラー', all_types:'全タイプ',
  clear_log:'ログをクリア', clearing:'クリア中…',
  no_errors_warnings:'エラーや警告はありません', total_events:'合計{n}件',
  refreshing:'更新中…',

  tab_sync_rules:'同期ルール', tab_shopify_app:'From Shopify',
  tab_app_ebay:'To eBay', tab_variations:'バリエーション',
  tab_inventory:'在庫', tab_pricing:'料金', tab_notifications:'通知',
  save_settings:'設定を保存', auto_sync_rules:'自動同期ルール',
  loading_settings:'設定を読み込み中…',
  settings_loaded:'データベースから設定を読み込みました',
  backend_offline:'バックエンドオフライン — 変更はローカルにのみ保存されます',
  every_n_mins:'{n}分ごと',

  save:'保存', cancel:'キャンセル', loading:'読み込み中…', refresh:'↺ 更新',
  create:'作成', edit:'編集', delete:'削除', close:'閉じる',
  search:'検索…', none:'なし', yes:'はい', no:'いいえ',
}

// ─── Chinese (Simplified) ─────────────────────────────────────
const zh = {
  nav_dashboard:'控制台', nav_products:'商品', nav_orders:'订单',
  nav_profiling:'商品规则', nav_activity:'活动日志', nav_pricing:'定价',
  nav_settings:'设置', nav_shopify:'账户详情', nav_templates:'模板', nav_help:'帮助与教程',
  menu:'菜单', shopify_synced:'Shopify已同步', not_synced:'未同步',
  sync_now:'立即同步', syncing:'同步中…', last_sync:'上次同步', language:'语言',

  total_revenue:'总收入', last_30_days:'过去30天', total_orders:'总订单数',
  total_products:'总商品数', active_on_ebay:'eBay上架中', inactive:'未激活',
  low_stock:'库存不足', out_of_stock:'缺货', ebay:'eBay',
  from_synced:'来自{n}个eBay同步订单', orders_month:'本月{n}个订单',
  imported:'从Shopify导入', total_listings:'共{n}个',
  paused_ebay:'在eBay上暂停', need_restock:'需要补货',
  zero_inventory:'零库存', connected:'已连接', not_connected:'未连接',
  synced:'{n}个已同步', sku_err:'{n}个SKU错误', failed:'{n}个失败',
  recent_orders:'最近订单', recent_activity:'最近活动',
  view_all:'查看全部 →', no_orders_yet:'暂无同步订单',
  fetch_orders:'获取eBay订单', no_activity:'暂无活动',
  live_data:'实时数据', no_data_yet:'暂无数据',
  import_products:'导入Shopify商品以查看控制台。',
  go_products:'⬡ 前往商品',

  import_shopify:'⬡ 从Shopify导入', publish_ebay:'发布到eBay',
  publishing:'发布中…', update_ebay:'在eBay上更新',
  link_ebay_listings:'关联eBay商品', no_products:'尚未导入商品',
  import_first:'导入您的Shopify商品以开始使用。',
  col_image:'图片', col_title:'标题', col_price:'价格',
  col_inventory:'库存', col_profile:'配置文件', col_status:'状态', col_actions:'操作',
  edit_product:'编辑商品', tab_basic:'基本信息', tab_variants:'变体',
  tab_quality:'eBay质量', field_title:'标题', field_description:'描述',
  field_price:'价格 ($)', field_inventory:'库存', field_vendor:'供应商',
  field_product_type:'商品类型', field_tags:'标签（逗号分隔）',
  field_status:'状态', shipping_dims:'运输与尺寸',
  digital_product:'数字商品',
  digital_no_shipping:'无需运输 — 在eBay上列为可下载',
  field_weight:'重量', field_dimensions:'尺寸 (长 × 宽 × 高)',
  save_to_app:'保存到应用', saving:'保存中…',
  status_active:'上架', status_draft:'草稿', status_archived:'已归档',
  no_variations:'无变体', col_variant:'变体', col_stock:'库存量',
  col_sku:'SKU', col_ignore:'忽略', assign_profile:'分配配置文件',
  unassign:'取消分配', select_profile:'选择配置文件',
  no_profiles_yet:'暂无配置文件 — 请在配置文件页面创建。',
  assigning:'分配中…', assign:'分配', analyzing:'分析商品中…',

  all_statuses:'全部状态', status_synced:'已同步',
  status_sku_error:'SKU错误', status_failed:'失败', status_pending:'待处理',
  col_receipt:'收据ID', col_buyer:'买家', col_items:'商品',
  col_total:'总计', col_shopify_order:'Shopify订单', col_ebay_date:'eBay日期',
  col_action:'操作', fetch_ebay_orders:'↓ 获取eBay订单',
  fetch_by_receipt:'# 按收据ID查找', fix_sku:'⚠ 修复SKU',
  retry:'✕ 重试', no_orders:'暂无订单', orders_count:'{n}个订单',
  from_label:'开始日期', to_label:'结束日期', fetch:'获取订单',
  fetching:'↺ 获取中…', fetch_single:'获取单个订单',
  ebay_receipt_id:'eBay收据ID', fix_sku_mapping:'修复SKU映射',
  create_shopify_order:'创建Shopify订单', creating_order:'创建订单中…',
  refresh_list:'刷新列表', done_fetched:'完成 — 已获取{n}个收据',

  all_events:'全部事件', errors_tab:'错误', all_types:'全部类型',
  clear_log:'清除日志', clearing:'清除中…',
  no_errors_warnings:'无错误或警告', total_events:'共{n}条',
  refreshing:'刷新中…',

  tab_sync_rules:'同步规则', tab_shopify_app:'来自Shopify',
  tab_app_ebay:'到eBay', tab_variations:'变体',
  tab_inventory:'库存', tab_pricing:'定价', tab_notifications:'通知',
  save_settings:'保存设置', auto_sync_rules:'自动同步规则',
  loading_settings:'加载设置中…',
  settings_loaded:'已从数据库加载设置',
  backend_offline:'后端离线 — 更改仅在本地保存',
  every_n_mins:'每{n}分钟',

  save:'保存', cancel:'取消', loading:'加载中…', refresh:'↺ 刷新',
  create:'创建', edit:'编辑', delete:'删除', close:'关闭',
  search:'搜索…', none:'无', yes:'是', no:'否',
}

const T = { en, es, fr, de, it, pt, nl, ja, zh }

// Interpolate {placeholder} variables
export function interp(str, vars = {}) {
  if (!str) return ''
  return str.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? '')
}

export default T
